import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth, PersonaBadge } from './AuthGate';
import AccessModal from './AccessModal';

const navItems = [
  { to: '/control/mission', label: 'Home', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1' },
  { to: '/developer', label: 'Workspace', icon: 'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z' },
  { to: '/developer/capabilities', label: 'Capabilities', icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10' },
  { to: '/developer/workflows', label: 'Workflows', icon: 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm0 8a1 1 0 011-1h6a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2zm0 0h14m-6 4h6' },
  { to: '/developer/runs', label: 'Runs', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
  { to: '/developer/library', label: 'Library', icon: 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z' },
  { to: '/control/mission', label: 'Control Tower', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
];

export default function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const { accessLevel } = useAuth();

  return (
    <>
      <nav className="nx-nav">
        <div className="nx-nav-inner">
          {/* Logo */}
          <NavLink to="/v2" className="nx-nav-logo">
            <div className="nx-logo-mark">N</div>
            <span className="nx-logo-text">Nexum Protocol</span>
          </NavLink>

          {/* Desktop links */}
          <div className="nx-nav-links">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/v2'}
                className={({ isActive }) =>
                  `nx-nav-link ${isActive ? 'nx-nav-link--active' : ''}`
                }
              >
                <svg
                  className="nx-nav-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
                </svg>
                {item.label}
              </NavLink>
            ))}
          </div>

          {/* Auth + Access */}
          <div className="nx-nav-status">
            {accessLevel === 'visitor' ? (
              <button className="nx-btn nx-btn--primary nx-btn--sm" onClick={() => setModalOpen(true)}>
                Get Access
              </button>
            ) : (
              <PersonaBadge />
            )}
          </div>

          {/* Mobile toggle */}
          <button
            className="nx-nav-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation"
          >
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              {mobileOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="nx-nav-mobile">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/v2'}
                className={({ isActive }) =>
                  `nx-nav-mobile-link ${isActive ? 'nx-nav-mobile-link--active' : ''}`
                }
                onClick={() => setMobileOpen(false)}
              >
                <svg
                  className="nx-nav-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
                </svg>
                {item.label}
              </NavLink>
            ))}
            {accessLevel === 'visitor' && (
              <button
                className="nx-btn nx-btn--primary nx-btn--sm"
                style={{ margin: '8px 16px' }}
                onClick={() => { setMobileOpen(false); setModalOpen(true); }}
              >
                Get Access
              </button>
            )}
          </div>
        )}
      </nav>

      <AccessModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
